import React from 'react';
import PropTypes from 'prop-types';
import ProjectStatusLabel from '../ProjectStatusLabel';
var defaultFunc = function defaultFunc() {
  return null;
};
var renderLabel = function renderLabel(labelType, copy) {
  return /*#__PURE__*/React.createElement("span", {
    className: "badge rounded-pill bg-".concat(labelType, " ms-2 px-6")
  }, copy);
};
var renderEmploymentTypeBadge = function renderEmploymentTypeBadge(type) {
  switch (type) {
    case 'full_time':
      return renderLabel('warning', 'Full Time');
    case 'consulting':
      return renderLabel('default', 'Consulting');
    default:
      return null;
  }
};
var renderTypeBadge = function renderTypeBadge(type) {
  switch (type) {
    case 'latent_demand':
      return renderLabel('success', 'Latent Demand');
    case 'request':
      return renderLabel('info', 'Request');
    case 'replacement':
      return renderLabel('default', 'Replacement');
    case 'open_marketplace':
      return renderLabel('warning', 'OM');
    case 'extension':
      return renderLabel('info', 'Extension');
    default:
      return null;
  }
};
function ProjectIndexRow(_ref) {
  var name = _ref.name,
    projectLink = _ref.projectLink,
    _ref$owner = _ref.owner,
    owner = _ref$owner === void 0 ? null : _ref$owner,
    ownerLink = _ref.ownerLink,
    _ref$company = _ref.company,
    company = _ref$company === void 0 ? null : _ref$company,
    _ref$companyLink = _ref.companyLink,
    companyLink = _ref$companyLink === void 0 ? null : _ref$companyLink,
    timestamp = _ref.timestamp,
    daysOpen = _ref.daysOpen,
    status = _ref.status,
    numProposals = _ref.numProposals,
    _ref$firstProposalSub = _ref.firstProposalSubmittedAt,
    firstProposalSubmittedAt = _ref$firstProposalSub === void 0 ? null : _ref$firstProposalSub,
    numInterests = _ref.numInterests,
    _ref$mostRecentIntere = _ref.mostRecentInterestTimestamp,
    mostRecentInterestTimestamp = _ref$mostRecentIntere === void 0 ? null : _ref$mostRecentIntere,
    _ref$editLink = _ref.editLink,
    editLink = _ref$editLink === void 0 ? null : _ref$editLink,
    editable = _ref.editable,
    _ref$specialFieldsLin = _ref.specialFieldsLink,
    specialFieldsLink = _ref$specialFieldsLin === void 0 ? null : _ref$specialFieldsLin,
    isPublic = _ref.isPublic,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? '' : _ref$type,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? defaultFunc : _ref$callback,
    index = _ref.index,
    _ref$assignedRep = _ref.assignedRep,
    assignedRep = _ref$assignedRep === void 0 ? {} : _ref$assignedRep,
    employmentType = _ref.employmentType,
    _ref$showEmploymentTy = _ref.showEmploymentType,
    showEmploymentType = _ref$showEmploymentTy === void 0 ? false : _ref$showEmploymentTy;
  return (
    /*#__PURE__*/
    // <div className="row d-flex align-items-center d-sm-block text-sm-center">
    React.createElement("div", {
      className: "d-sm-flex text-center text-sm-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 col-md-4"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "mt-0 mb-0"
    }, /*#__PURE__*/React.createElement("a", {
      href: projectLink,
      target: "_blank",
      className: "admin-project-show",
      rel: "noreferrer"
    }, name), isPublic && renderLabel('primary', 'Public'), renderTypeBadge(type), showEmploymentType && renderEmploymentTypeBadge(employmentType)), /*#__PURE__*/React.createElement("h5", {
      className: "mt-0 mb-0"
    }, /*#__PURE__*/React.createElement("small", {
      className: "fs-hide"
    }, /*#__PURE__*/React.createElement("a", {
      href: ownerLink,
      className: "fs-hide project-owner"
    }, owner), "\xA0\u2022\xA0", /*#__PURE__*/React.createElement("a", {
      href: companyLink,
      className: "company-name"
    }, company))), /*#__PURE__*/React.createElement("h6", {
      className: "mt-0 mb-0"
    }, /*#__PURE__*/React.createElement("small", null, timestamp, ' ', "\xA0\u2022\xA0", ' ', daysOpen, ' ', "Days Opened"))), /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 col-md-3"
    }, /*#__PURE__*/React.createElement(ProjectStatusLabel, {
      status: status
    }), assignedRep && assignedRep.name), /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 col-md-1"
    }, numProposals, ' ', "Proposal(s)", /*#__PURE__*/React.createElement("h5", {
      className: "mt-0 mb-0"
    }, /*#__PURE__*/React.createElement("small", null, firstProposalSubmittedAt))), /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 col-md-1"
    }, numInterests, ' ', "Resume(s)", /*#__PURE__*/React.createElement("h5", {
      className: "mt-0 mb-0"
    }, /*#__PURE__*/React.createElement("small", null, mostRecentInterestTimestamp))), /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 col-md-3 "
    }, editable ? /*#__PURE__*/React.createElement("a", {
      href: editLink,
      className: "btn btn-small btn-default me-2"
    }, "Edit") : null, status === 'employer_draft' ? /*#__PURE__*/React.createElement("button", {
      className: "btn btn-small btn-primary me-2",
      value: index,
      onClick: callback
    }, "Request Matching") : null, status === 'employer_requested_matching' ? /*#__PURE__*/React.createElement("button", {
      className: "btn btn-small btn-info",
      value: index,
      onClick: callback
    }, "Begin Matching") : null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group float-end"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn btn-default more-menu dropdown-toggle",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "dropdown-menu"
    }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      className: "dropdown-item",
      href: specialFieldsLink
    }, "Change Owner")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      className: "dropdown-item",
      href: specialFieldsLink
    }, "Status Change Tracking"))))))
  );
}
ProjectIndexRow.propTypes = {
  name: PropTypes.string.isRequired,
  projectLink: PropTypes.string.isRequired,
  owner: PropTypes.string,
  ownerLink: PropTypes.string.isRequired,
  company: PropTypes.string,
  companyLink: PropTypes.string,
  timestamp: PropTypes.string.isRequired,
  daysOpen: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  numProposals: PropTypes.number.isRequired,
  firstProposalSubmittedAt: PropTypes.string,
  numInterests: PropTypes.number.isRequired,
  mostRecentInterestTimestamp: PropTypes.string,
  editable: PropTypes.bool.isRequired,
  editLink: PropTypes.string,
  specialFieldsLink: PropTypes.string,
  isPublic: PropTypes.bool.isRequired,
  type: PropTypes.string,
  callback: PropTypes.func,
  index: PropTypes.number.isRequired,
  assignedRep: PropTypes.shape({}),
  employmentType: PropTypes.string.isRequired,
  showEmploymentType: PropTypes.bool
};
export default ProjectIndexRow;